import React from 'react';
import { Container, Row, Col, Card, Tab, Nav, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FalconCardHeader from '../common/FalconCardHeader';

const ClientReportsPage = () => {
  return (
    <Container fluid className="px-3">
      <div className="pb-4">
        {/* Header */}
        <div className="mb-4">
          <Row className="align-items-center">
            <Col>
              <h2 className="mb-2">
                <FontAwesomeIcon icon="file-alt" className="me-2 text-primary" />
                Reportes de Clientes
              </h2>
              <h5 className="text-700 fw-semi-bold">
                Genera y visualiza reportes detallados de tus clientes
              </h5>
            </Col>
            <Col xs="auto">
              <Button variant="primary">
                <FontAwesomeIcon icon="plus" className="me-1" />
                Nuevo Reporte
              </Button>
            </Col>
          </Row>
        </div>

        <Card className="shadow-sm">
          <FalconCardHeader title="Reportes Disponibles" />
          <Card.Body>
            <Tab.Container defaultActiveKey="performance">
              <Nav variant="tabs" className="justify-content-center mb-3">
                <Nav.Item>
                  <Nav.Link eventKey="performance">
                    <FontAwesomeIcon icon="chart-line" className="me-1" />
                    Performance
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="financial">
                    <FontAwesomeIcon icon="dollar-sign" className="me-1" />
                    Financiero
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="roi">
                    <FontAwesomeIcon icon="chart-bar" className="me-1" />
                    ROI Analysis
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="custom">
                    <FontAwesomeIcon icon="cog" className="me-1" />
                    Personalizado
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              
              <Tab.Content>
                <Tab.Pane eventKey="performance">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="chart-line" size="3x" className="text-primary mb-3" />
                    <h5>Reportes de Performance</h5>
                    <p className="text-muted">
                      Analiza el rendimiento de las campañas de tus clientes
                    </p>
                    <ul className="list-unstyled text-muted">
                      <li>📊 Métricas de engagement y conversión</li>
                      <li>📈 Tendencias de performance por período</li>
                      <li>🎯 Comparativa vs objetivos</li>
                      <li>📱 Performance por canal y plataforma</li>
                    </ul>
                  </div>
                </Tab.Pane>
                
                <Tab.Pane eventKey="financial">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="dollar-sign" size="3x" className="text-success mb-3" />
                    <h5>Reportes Financieros</h5>
                    <p className="text-muted">
                      Estados financieros y análisis de inversión
                    </p>
                    <ul className="list-unstyled text-muted">
                      <li>💰 Inversión total por cliente</li>
                      <li>📊 Distribución de presupuesto</li>
                      <li>💸 Análisis de costos por adquisición</li>
                      <li>📈 Proyecciones financieras</li>
                    </ul>
                  </div>
                </Tab.Pane>
                
                <Tab.Pane eventKey="roi">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="chart-bar" size="3x" className="text-info mb-3" />
                    <h5>Análisis de ROI</h5>
                    <p className="text-muted">
                      Retorno de inversión detallado por cliente
                    </p>
                    <ul className="list-unstyled text-muted">
                      <li>🎯 ROAS por campaña y cliente</li>
                      <li>📊 ROI a corto y largo plazo</li>
                      <li>💡 Oportunidades de optimización</li>
                      <li>📈 Benchmarking vs industria</li>
                    </ul>
                  </div>
                </Tab.Pane>
                
                <Tab.Pane eventKey="custom">
                  <div className="text-center py-5">
                    <FontAwesomeIcon icon="cog" size="3x" className="text-warning mb-3" />
                    <h5>Reportes Personalizados</h5>
                    <p className="text-muted">
                      Crea reportes adaptados a tus necesidades específicas
                    </p>
                    <ul className="list-unstyled text-muted">
                      <li>🔧 Constructor de reportes drag & drop</li>
                      <li>📅 Programación automática</li>
                      <li>📧 Envío por email</li>
                      <li>📊 Múltiples formatos de exportación</li>
                    </ul>
                  </div>
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Card.Body>
        </Card>

        {/* Reportes recientes */}
        <Row className="mt-4">
          <Col>
            <Card className="shadow-sm">
              <FalconCardHeader title="Reportes Recientes" />
              <Card.Body>
                <div className="text-center py-4">
                  <FontAwesomeIcon icon="file-alt" size="2x" className="text-muted mb-3" />
                  <h6>No hay reportes recientes</h6>
                  <p className="text-muted">
                    Genera tu primer reporte para comenzar a analizar los datos de tus clientes
                  </p>
                  <Button variant="primary">
                    <FontAwesomeIcon icon="plus" className="me-1" />
                    Crear Primer Reporte
                  </Button>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default ClientReportsPage; 